// SurveyGuard.js
import { useParams, Navigate } from 'react-router-dom';
import { allSurveys } from './data';

const SurveyGuard = ({ children }) => {
    const { testSlug } = useParams();
    
    if (!allSurveys[testSlug]) {
        return <Navigate to="/" replace />;
    }

    return children;
};

export default SurveyGuard;